import {createAction} from "@reduxjs/toolkit";
import {AUTH, DONE, FAIL, FETCH,RESET, SET, REGISTER_DATA, RESTORE_DATA, GET_PROFILE, EMBED_DATA, GET_MODULES, SPECIALISTS, REVIEWS_LIST, RESEND_CODE, CONFIRM_RESET_PASSWORD, CONFIRM_PASSWORD} from "../../constants"

export const fetchAuth = createAction<any>(AUTH + FETCH)
export const fetchAuthDone = createAction<any>(AUTH + FETCH + DONE)
export const fetchAuthFail = createAction<undefined>(AUTH + FETCH + FAIL)
export const getUserProfileActionReset = createAction<undefined>(AUTH + RESET);

export const fetchRegister = createAction<any>(REGISTER_DATA + FETCH)
export const fetchRegisterDone = createAction<any>(REGISTER_DATA + FETCH + DONE)
export const fetchRegisterFail = createAction<undefined>(REGISTER_DATA + FETCH + FAIL)
export const clearRegisterData = createAction(REGISTER_DATA + RESET);

export const fetchRestore = createAction<any>(RESTORE_DATA + FETCH)
export const fetchRestoreDone = createAction<any>(RESTORE_DATA + FETCH + DONE)
export const fetchRestoreFail = createAction<undefined>(RESTORE_DATA + FETCH + FAIL)

export const getSpecialists = createAction<any>(SPECIALISTS + FETCH);
export const getSpecialistsDone = createAction<any>(SPECIALISTS + FETCH + DONE);
export const getSpecialistsFail = createAction<undefined>(SPECIALISTS + FETCH + FAIL);

export const fetchGetProfile = createAction<any|undefined>(GET_PROFILE + FETCH)
export const fetchGetProfileDone = createAction<undefined>(GET_PROFILE + FETCH + DONE)
export const fetchGetProfileFail = createAction<undefined>(GET_PROFILE + FETCH + FAIL)

export const fetchModules = createAction<any>(GET_MODULES + FETCH)
export const fetchModulesDone = createAction<any>(GET_MODULES + FETCH + DONE)
export const fetchModulesFail = createAction<undefined>(GET_MODULES + FETCH + FAIL)

export const setRegisterData = createAction<any>(SET + REGISTER_DATA)
export const setEmbedData = createAction<any>(SET + EMBED_DATA)

export const setRestoreData = createAction(SET + RESTORE_DATA);

export const fetchReviewsListAction = createAction<any>(REVIEWS_LIST + FETCH)
export const fetchReviewsListDone = createAction<any>(REVIEWS_LIST + FETCH + DONE)
export const fetchReviewsListFail = createAction<any>(REVIEWS_LIST + FETCH + FAIL)

export const fetchResendCodeAction = createAction<any>(RESEND_CODE + FETCH)
export const fetchResendCodeDone = createAction<any>(RESEND_CODE + FETCH + DONE)
export const fetchResendCodeFail = createAction<any>(RESEND_CODE + FETCH + FAIL)

export const fetchConfirmResetPasswordAction = createAction<any>(CONFIRM_RESET_PASSWORD + FETCH)
export const fetchConfirmResetPasswordDone = createAction<any>(CONFIRM_RESET_PASSWORD + FETCH + DONE)
export const fetchConfirmResetPasswordFail = createAction<any>(CONFIRM_RESET_PASSWORD + FETCH + FAIL)

export const fetchConfirmPasswordAction = createAction<any>(CONFIRM_PASSWORD + FETCH)
export const fetchConfirmPasswordDone = createAction<any>(CONFIRM_PASSWORD + FETCH + DONE)
export const fetchConfirmPasswordFail = createAction<any>(CONFIRM_PASSWORD + FETCH + FAIL)